import { TravelerAvailableDocumentTypes } from 'common/graphql/__generated__/TravelerAvailableDocumentTypes';
import { useFormikContext } from 'formik';
import React from 'react';
import { Traveler_traveler } from '../../../__generated__/Traveler';
import { AttachFormModal } from './AttachFormModal';
export interface AttachFormProps {
  availableDocumentTypes: TravelerAvailableDocumentTypes | undefined;
  traveler: Traveler_traveler;
}

export const AttachForm: React.FC<AttachFormProps> = ({
  traveler,
  availableDocumentTypes,
}) => {
  const { dirty } = useFormikContext<any>();

  return (
   
        <AttachFormModal
          traveler={traveler}
          availableDocumentTypes={availableDocumentTypes}
          isDirty={dirty}
        />
      
   
  );
};
